import { IS_LOADING, SETTINGS_LIST_SUCCESS, SETTINGS_LIST_ERROR, SETTINGS_UPDATE_SUCCESS, SETTINGS_UPDATE_ERROR } from "../actions/Type";

const initialState = {
    setting_list: {},
    setting_update: {},
    loading: false,
};

export const SettingsReducers = (
    state = initialState,
    { type, payload } = {},
) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case SETTINGS_LIST_SUCCESS:
            return {
                ...state,
                setting_list: payload,
                loading: false,
            };
        case SETTINGS_LIST_ERROR:
            return {
                ...state,
                setting_list: payload,
                loading: false,
            };

        case SETTINGS_UPDATE_SUCCESS:
            return {
                ...state,
                setting_update: payload,
                loading: false,
            };
        case SETTINGS_UPDATE_ERROR:
            return {
                ...state,
                setting_update: payload,
                loading: false,
            };
        default:
            return state;
    }
};
